











import { Component, Vue } from "vue-property-decorator";
import { IMenuRoute } from "@/models/routes";

@Component
export default class AdminEmailHistory extends Vue {
  public get defaultRoutes(): IMenuRoute[] {
    return [
      {
        label: this.$t("_.all"),
        to: {
          name: "adminEmailLogsAll"
        }
      },
      {
        label: this.$t("_.sent"),
        to: {
          name: "adminEmailLogsSent"
        }
      },
      {
        label: this.$t("_.bounced"),
        to: {
          name: "adminEmailLogsBounced"
        }
      },
      {
        label: this.$t("_.failed"),
        to: {
          name: "adminEmailLogsFailed"
        }
      }
    ];
  }
}
